import type * as ents from '@attain-apps/entities'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State {
  /** @see {@link ents.core.mosaic.Page.Rendering} */
  page?: ents.core.mosaic.Page.Rendering
  isLoading: boolean
  error?: Error | string
}
export namespace State {
  export const INITIAL: NoMissing<State> = {
    error: undefined,
    isLoading: false,
    page: undefined,
  }
}
